import { useSelector } from 'react-redux';
import { DataSink } from 'new/entities/DataSink';
import DateUtils from 'js/lib/DateUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import { CONNECTION_CATEGORY_DATA_MAP } from 'js/constants/connectionCategories';
import has from 'lodash/has';

const NoResourceResponse = {
  writingDataSet: null,
  isWritingDataset: false,
  configurationsJSON: '',
  lastUpdate: 0,
  createdDate: 0,
  credentials: null,
  resourceTypeFields: null,
  isDataMap: false,
  connectionCategory: null,
};

export function useDestinationOverview(data: DataSink) {
  const { vendors, dataSets, credentials } = useSelector((state: any) => state.entities);
  const { metaInfoById, sinkConfigById } = useSelector((state: any) => state.paging);

  /**
   * if the resource was not provided for some reason
   * returning a mock object to avoid UI crashing
   */
  if (!data || typeof data !== 'object') return NoResourceResponse;

  const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
  const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);

  const hasDataSetID = Boolean(data?.data_set_id);
  const writingDataSet =
    hasDataSetID && data.data_set_id in dataSets ? dataSets[data.data_set_id] : null;

  const { sink_config, template_config = {} } = data;
  const configurations = Object.keys(template_config).length
    ? { sink_config, template_config }
    : { sink_config };
  const configurationsJSON = JSON.stringify(configurations);

  const connectionOrVendorType = getConnectionOrVendorType(data, vendors, 'sink_type', 'vendor_id');

  const connectionCategory =
    metaInfoById && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType].connectionCategory
      : null;

  const resourceTypeFields = has(sinkConfigById, connectionOrVendorType)
    ? sinkConfigById[connectionOrVendorType]
    : [];

  const isDataMap = connectionCategory === CONNECTION_CATEGORY_DATA_MAP;

  return {
    connectionCategory,
    isDataMap,
    resourceTypeFields,
    writingDataSet,
    isWritingDataset: hasDataSetID,
    configurationsJSON,
    lastUpdate,
    createdDate,
    credentials:
      typeof data?.data_credentials === 'number' ? credentials[data.data_credentials] : null,
  };
}
